export type WhoAmIResponse = {
    id: string;
    first_name: string;
    last_name: string;
    authorities: Array<Authority>;
};

export enum Authority {
    USER = "USER",
    ADMIN = "ADMIN",
}

export type LoginRequest = {
    username: string;
    password: string;
};

export type TokenResponse = {
    token: string;
};
